import { withInstall, withNoopInstall } from '@zoryn/utils'
import Descriptions from './src/description.vue'
import DescriptionsItem from './src/description-item'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDescriptions: SFCWithInstall<typeof Descriptions> & {
  DescriptionsItem: typeof DescriptionsItem
} = withInstall(Descriptions, {
  DescriptionsItem,
})

export const ZDescriptionsItem: SFCWithInstall<typeof DescriptionsItem> =
  withNoopInstall(DescriptionsItem)

export default ZDescriptions

export * from './src/description'
export * from './src/description-item'
